import { createAsyncThunk } from "@reduxjs/toolkit";

import { IError } from "@/models/inner-models";

import instance from "../middleware/api";

export interface IBillingAddress {
  id: string;
  userId: string;
  firstName: string;
  lastName: string;
  companyName?: string;
  customerType: string;
  street: string;
  addressLine2?: string;
  city: string;
  stateRegion?: string;
  zipCode: string;
  country: string;
  vatId?: string;
  companyNo?: string;
  isDefault: boolean;
  createdAt: string;
  updatedAt: string;
}

export type CreateBillingAddressPayload = Omit<IBillingAddress, "id" | "userId" | "createdAt" | "updatedAt">;
export type UpdateBillingAddressPayload = Partial<CreateBillingAddressPayload>;

export const fetchBillingAddresses = createAsyncThunk<IBillingAddress[]>(
  "billingAddresses/fetchAll",
  async (_, thunkAPI) => {
    try {
      const resp = await instance.get("/billing-addresses");
      return resp.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err as IError);
    }
  },
);

export const createBillingAddress = createAsyncThunk<IBillingAddress, CreateBillingAddressPayload>(
  "billingAddresses/create",
  async (data, thunkAPI) => {
    try {
      const resp = await instance.post("/billing-addresses", data);
      return resp.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err as IError);
    }
  },
);

export const updateBillingAddress = createAsyncThunk<IBillingAddress, { id: string; data: UpdateBillingAddressPayload }>(
  "billingAddresses/update",
  async ({ id, data }, thunkAPI) => {
    try {
      const resp = await instance.patch(`/billing-addresses/${id}`, data);
      return resp.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err as IError);
    }
  },
);

export const deleteBillingAddress = createAsyncThunk<string, string>(
  "billingAddresses/delete",
  async (id, thunkAPI) => {
    try {
      await instance.delete(`/billing-addresses/${id}`);
      return id;
    } catch (err) {
      return thunkAPI.rejectWithValue(err as IError);
    }
  },
);

export const setDefaultBillingAddress = createAsyncThunk<IBillingAddress, string>(
  "billingAddresses/setDefault",
  async (id, thunkAPI) => {
    try {
      const resp = await instance.patch(`/billing-addresses/${id}/default`);
      return resp.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err as IError);
    }
  },
);
